import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useMemo } from 'react';
import { View, ScrollView, Linking } from 'react-native';
import styled from 'styled-components/native';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import { ResponsiveProvider, useResponsive, } from '../BbucleRoadScreen/context/ResponsiveContext';
import { getAllBbucleRoadList } from '../BbucleRoadScreen/config/bbucleRoadData';
import ListHeader from './components/ListHeader';
import BbucleRoadCard from './components/BbucleRoadCard';
const CONTENTS_ALARM_FORM_URL = 'https://forms.staircrusher.club/contents-alarm';
// 공개 예정 카드 데이터
const UPCOMING_CARDS = [
    {
        id: 'upcoming-1',
        title: '새로운 공연장 정보가 곧 공개됩니다',
        subtitle: '알림 신청하고 먼저 소식 받아보세요',
    },
];
function BbucleRoadListContent({ navigation, }) {
    const { isDesktop } = useResponsive();
    // createdAt descending 정렬
    const sortedBbucleRoadList = useMemo(() => {
        return getAllBbucleRoadList().sort((a, b) => {
            const dateA = a.createdAt || '1970-01-01';
            const dateB = b.createdAt || '1970-01-01';
            return dateB.localeCompare(dateA);
        });
    }, []);
    const handleCardPress = (bbucleRoadId) => {
        navigation.navigate('BbucleRoad', { bbucleRoadId });
    };
    const handleUpcomingCardPress = () => {
        Linking.openURL(CONTENTS_ALARM_FORM_URL);
    };
    return (_jsx(LogParamsProvider, { params: { displayScreenName: 'BbucleRoadList', isDesktop }, children: _jsxs(ScrollView, { style: { flex: 1 }, children: [_jsx(ListHeader, {}), _jsxs(CardListContainer, { isDesktop: isDesktop, children: [UPCOMING_CARDS.map(upcomingItem => (_jsx(BbucleRoadCard, { upcomingData: upcomingItem, onPress: handleUpcomingCardPress, isDesktop: isDesktop }, upcomingItem.id))), sortedBbucleRoadList.map(item => (_jsx(BbucleRoadCard, { data: item, onPress: () => handleCardPress(item.id), isDesktop: isDesktop }, item.id)))] }), _jsx(FooterSpacer, {})] }) }));
}
export default function BbucleRoadListScreen({ navigation }) {
    return (_jsx(Container, { testID: "bbucle-road-list", children: _jsx(ResponsiveProvider, { children: _jsx(BbucleRoadListContent, { navigation: navigation }) }) }));
}
const Container = styled(View) `
  flex: 1;
  background-color: #ffffff;
  overflow: hidden;
`;
const CardListContainer = styled(View) `
  width: 100%;
  max-width: ${({ isDesktop }) => (isDesktop ? '800px' : '100%')};
  align-self: center;
  padding: ${({ isDesktop }) => (isDesktop ? '32px 0' : '24px 16px')};
  gap: ${({ isDesktop }) => (isDesktop ? '24px' : '16px')};
  box-sizing: border-box;
`;
const FooterSpacer = styled(View) `
  height: 60px;
`;
